import React from 'react';
import { withJsonFormsControlProps } from '@jsonforms/react';
import Date from '../components/Date';
import { inputProps } from '../interface/inputfieldProps';
import DateAndTime from '../components/DateAndTime';

const ControlDate = (props: inputProps) => {
  return(
    <DateAndTime
     {...props}
   />)
  }

export default withJsonFormsControlProps(ControlDate);